<template>
  <div>
    <div id="add-symptoms" class="panel active">
      <div class="panel-content px-xs-4 px-md-0 pt-xs-4 pt-md-80">
        <h1>You didn’t tick the following signs</h1>
        <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
        <h2 v-if="ageGroup" v-html="$getTemplatedString('ADD_SYMPTOMS_ARE_YOU_SURE', { 'age_state': ageGroup.state })"></h2>
        <p class="smaller fg-sma-black-75" v-html="$getString('ADD_SYMPTOMS_ADD_MORE')"></p>
        <ul id="unchecked-items" class="symptomlist column-list bordered">
          <li v-for="symptom in availableSymptoms" :key="symptom.index">
            <div class="symptom-wrapper">
              <div :class="[ 'symptom-header checkbox-container', { active: newSymptoms.indexOf(symptom.index) > -1 } ]" @click.prevent="select(symptom.index)">
                <div :class="[ 'checkbox', { checked: newSymptoms.indexOf(symptom.index) > -1 } ]"></div>
                <p v-html="symptom.label"></p>
              </div>
            </div>
          </li>
          <li>
            <div class="symptom-wrapper no-shadow">
              <div :class="[ 'symptom-header checkbox-container no-selection', { active: newSymptoms.indexOf(-1) > -1 } ]" @click.prevent="select(-1)">
                <div :class="[ 'checkbox', { checked: newSymptoms.indexOf(-1) > -1 } ]"></div>
                <p v-html="$getString('GLOBAL_NOT_CONCERNED')"></p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="questionnaire-buttons container text-centered">
      <div class="tool-button previous mx-xs-2" @click="onPrevious" v-html="$getString('GLOBAL_BUTTON_BACK')"></div>
      <div :class="[ 'tool-button next mx-xs-2', { disabled: !next } ]" @click="onNext" v-html="$getString('GLOBAL_BUTTON_NEXT')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StageAddSymptoms',
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      age: -1,
      ageGroup: null,
      symptoms: [],
      newSymptoms: [],
      availableSymptoms: [],
      next: false,

      handlers: [],
    }
  },
  methods: {
    onPrevious() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Back`,
      } });

      const symptoms = this.$store.getters.dataKey('symptoms');
      if (symptoms.length > 0 && symptoms[0] > -1) {
        this.$emit('action', { type: 'decrement-page' });
        this.$emit('action', { type: 'goto-stage', data: 'questions' });
      } else {
        this.$emit('action', { type: 'decrement-page' });
        this.$emit('action', { type: 'decrement-page' });
        this.$emit('action', { type: 'goto-stage', data: 'symptoms' });
      }
    },
    onNext() {
      if (!this.next) return;

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Continue`,
      } });

      this.updateSymptoms();
      this.$emit('action', { type: 'increment-page' });
      if (this.newSymptoms[0] > -1) {
        this.$emit('action', { type: 'goto-stage', data: 'questions' });
      } else if (this.symptoms[0] > -1) {
        this.$emit('action', { type: 'goto-stage', data: 'sliders' });
      } else {
        this.$emit('action', { type: 'goto-stage', data: 'summary-alt' });
      }
    },
    openSymptomPopup(index) {
      const symptom = this.ageGroup.symptoms[index];
      this.$emit('action', { type: 'open-popup', data: {
        type: 'symptom',
        heading: symptom.label,
        items: symptom.popupList,
      }});
    },

    validateSymptomsArray(index) {
      if (index === -1) {
        if (this.newSymptoms.length > 0 && this.newSymptoms.indexOf(-1) === -1) {
          this.newSymptoms = [];
        }
      } else if (this.newSymptoms.indexOf(-1) > -1) {
        this.newSymptoms = [];
      }
    },
    select(index) {
      this.validateSymptomsArray(index);

      const analyticsValue = index > -1 
        ? this.ageGroup.symptoms[index].analytics 
        : 'Not_concerned';
      
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_${analyticsValue}`,
      } });

      const arrIndex = this.newSymptoms.indexOf(index);
      if (arrIndex > -1) {
        this.newSymptoms.splice(arrIndex, 1);
      } else {
        this.newSymptoms.push(index);
      }
      this.checkNextButton();
    },
    checkNextButton() {
      this.next = this.newSymptoms.length > 0;
    },

    getSymptoms() {
      const symptoms = this.$store.getters.dataKey('symptoms');
      this.availableSymptoms = [];
      this.ageGroup.symptoms.forEach(symptom => {
        if (symptoms.indexOf(symptom.index) < 0) {
          this.availableSymptoms.push(JSON.parse(JSON.stringify(symptom)));
        }
      });
    },
    updateSymptoms() {
      this.symptoms = this.$store.getters.dataKey('symptoms');
      if (this.symptoms[0] === -1)
        this.symptoms.shift();
      
      this.newSymptoms.forEach(symptom => {
        if (symptom > -1)
          this.symptoms.push(this.ageGroup.symptoms[symptom].index);
      });
      this.$store.commit('SetData', { key: 'symptoms', value: this.symptoms });
      this.initialiseQuestions();
    },
    getAnswers(question) {
      const currentQuestions = this.$store.getters.dataKey('questions');
      if (currentQuestions) {
        const currentIndex = currentQuestions.findIndex(item => item.index === question.index);
        if (currentIndex > -1) {
          return currentQuestions[currentIndex].answers;
        }
      }
      return [];
    },
    initialiseQuestions() {
      const buffer = this.ageGroup.questions.filter(question => this.newSymptoms.indexOf(question.symptom) > -1);
      const questionIndex = this.$store.getters.dataKey('question');
      const questions = this.$store.getters.dataKey('questions');

      buffer.forEach(question => {
        const questionCopy = JSON.parse(JSON.stringify(question));
        questionCopy.answers = this.getAnswers(question);
        questions.push(questionCopy);
      });

      this.$emit('action', { type: 'set-pages', data: questions.length });
      this.$store.commit('SetData', { key: 'questions', value: questions });
      this.$store.commit('SetData', { key: 'question', value: questionIndex + 1 });
      this.$store.commit('SetData', { key: 'addedSymptoms', value: true });
    },
  },
  mounted() {
    this.$emit('action', { type: 'increment-page' });
    this.age = this.$store.getters.dataKey('age');
    this.ageGroup = this.$store.getters.ageGroup;
    this.getSymptoms();
    this.checkNextButton();
  },
}
</script>
